
































import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import TableActionDelete from "@/components/Helper/Table/TableActionDelete.vue";

const NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS: string = 'timeTrackingManagementCustomers';
const RESOURCE_TIME_TRACKING_MANAGEMENT_CUSTOMERS: string = 'tt/management/customers';
@Component({
  components: {TableActionDelete}
})
export default class List extends Vue {
  public name: string = "List";

  @Action('load', {namespace: NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS}) loadListItems: any;
  @Action('deleteItem', {namespace: NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS}) deleteItem: any;
  @Action('removeItemFromDataList', {namespace: NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS}) removeItemFromDataList: any

  @Getter('getDataList', {namespace: NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS}) customersList: any;

  private onDelete(id: number) {

    // removed console_log
    this.deleteItem({
      resource: RESOURCE_TIME_TRACKING_MANAGEMENT_CUSTOMERS,
      id: id
    }, true).then((resource: any) => {

      // removed console_log
      this.removeItemFromDataList({needle: id, column: 'id'});

    });

  }

  mounted() {

    this.loadListItems({
      resource: RESOURCE_TIME_TRACKING_MANAGEMENT_CUSTOMERS
    });

  }

}
